<template>
<div class="contents">
    <div class="wrap">
        <section>
          <h2 class="page_title --view">그룹코드 신규 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <!--
                <tr>
                  <th><span>코드</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.grpCode">
                  </td>
                </tr>
                -->
                <tr>
                  <th><span>코드명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.grpCodeNm">
                  </td>
                </tr>        
                <tr>
                  <th><span>설명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.codeExpl">
                  </td>
                </tr>        
                <tr>
                  <th><span>사용유무</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="radio1" name="radio" value="Y" v-model="regData.useYn">
                        <label for="radio1">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="radio2" name="radio" value="N" v-model="regData.useYn">
                        <label for="radio2">N</label>
                      </div>
                    </div>                   
                  </td>
                </tr>        
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- button class="btn btn_md btn_gray">취소</button -->
                <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
import axios from 'axios'

  export default {
    name: 'CodeMngtRegGrp',
    data() {
        return {
            regData : {
                grpCode : "",
                grpCodeNm : "",
                codeExpl : "",
                useYn : "Y",
                status : 'I'
            }
        }
    },
    created(){
      console.log("@@@@@@ aaaa");
      this.regData.grpCode = this.$store.getters['codeMngt/getCode'];

      if(this.regData.grpCode){
        this.regData.status = "M";

        this.fn_search_grpCode();
      }

      
    },
    methods : {
        fn_reg(){

            //console.log("@@@@ regData : %o",this.regData);

            axios.post("/api/system/regCodeGrp", 
                    this.regData
                ).then((res) => {
                console.log("@@@@ res : %o",res);
                this.$store.dispatch('codeMngt/setCode', ''); 
                alert("저장되었습니다");
                this.fn_move_page();
            })
            .catch((err) => console.log(err));

        
        },
        fn_move_page(){
            this.$store.dispatch('codeMngt/setCode', ''); 
            this.$router.push("/admin/system/codeMngt");
        },
        fn_search_grpCode(){

            axios.post("/api/system/searchGroupCode", 
                    this.regData
                ).then((res) => {
                console.log("@@@@ res : %o",res);

                this.regData.grpCodeNm = res.data.groupCodeInfo.code_nm;
                this.regData.codeExpl = res.data.groupCodeInfo.code_expl;
                this.regData.useYn = res.data.groupCodeInfo.use_yn;


            })
            .catch((err) => console.log(err));
        }
    }
  }
</script>